import { PureComponent } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logError } from './actions';

class ErrorBoundary extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    onLogError: PropTypes.func.isRequired,
    pathname: PropTypes.string,
  };

  state = { error: null, errorInfo: null };

  componentDidUpdate(prevProps) {
    const { pathname } = this.props;
    if (this.state.errorInfo && pathname && pathname !== prevProps.pathname) {
      this.setState({ error: null, errorInfo: null });
    }
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState(
      {
        error,
        errorInfo,
      },
      () => {
        this.props.onLogError({
          error: `${error}${this.state.errorInfo.componentStack}`,
          origin: 'COMPONENT',
        });
      },
    );
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <div className='m-4'>
          <h2>
            <i className='fa fa-warning' /> Something went wrong.
          </h2>
          <p>
            You can try to{' '}
            {/* biome-ignore lint/a11y/useValidAnchor: for simplistic styling on the screen of death */}
            <a
              href='#'
              onClick={() => {
                window.location.reload();
              }}
            >
              reload the page
            </a>{' '}
            or <a href='/'>go to homepage</a> to continue working.
          </p>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            <p className='text-danger'>
              When troubleshooting this issue, it is advised to check also error
              details from browser console as they may contain more precise
              information. Also, there may be other clues like failed API calls
              that resulted into this frontend error.
            </p>
            {this.state.error?.toString()}
            <br />
            {this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    onLogError: (args) => dispatch(logError(args)),
  };
}

export default connect(() => ({}), mapDispatchToProps)(ErrorBoundary);
